import React from 'react'
import { TailSpin } from 'react-loader-spinner'
import { toggleMenu } from '../utils/helpers'
import PageTitle from './PageTitle'
import Footer from './Footer'

const PageLayout = ({children, title, description, isLoading}) => {
  return (
    <div className="wrapper-body">
      {isLoading && (
        <div className="overlay">
          <div className="loader-container">
            <TailSpin height="100" width="100" radius="1" color="blue" ariaLabel="tail-spin-loading" wrapperStyle={{}} wrapperClassName="" visible={true} />
          </div>
        </div>
      )}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
      </div>
      {children}
      <Footer />
    </div>
  )
}

export default PageLayout